/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExternalDocumentation } from './ExternalDocumentation';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IExternalDocumentationParent {
    /**
     * Creates an external documentation.
     * @return {ExternalDocumentation}
     */
    createExternalDocumentation() : ExternalDocumentation;

    /**
     * Sets the external documentation.
     * @param {ExternalDocumentation} externalDocs
     */
    setExternalDocumentation(externalDocs : ExternalDocumentation);
}


